export function twoDigitRounded(value: number) {
    return Math.round(value * 100) / 100
}